/* eslint-disable react-hooks/exhaustive-deps */
//#region Libraries
import { USER_ROLES } from "config/userPermissions";
import { useEffect, useState } from "react";
//#endregion
//#region Services
import { requestGetResourceModules } from "services/settings/scheduleAdmin/relatedToScheduleAdmin";
import { requestGetLibraryReasonsForPenalize, requestGetResourceTypes } from "services/resources/library/relatedToLibraryResources";
import { requestGetBlockList, requestGetPenalties } from "services/resources/relatedToResources";
import { requestGetUniversitySpaceReasonsForPenalize } from "services/resources/universitySpaces/relatedToUniversitySpaceResources";
//#endregion

const useDataRelatedToPenaltyAdmin = ({
    loadingRequest,
    setFatalError, userRole
}) => {
    //#region States
    const [campusSpaceList, setCampusSpaceList] = useState([]);
    const [resourceTypes, setResourceTypes] = useState([]);
    const [libraryReasonsForPenalize, setLibraryReasonsForPenalize] = useState([]);
    const [universitySpaceReasonsForPenalize, setUniversitySpaceReasonsForPenalize] = useState([]);
    const [blockList, setBlockList] = useState([]);
    const [penaltyTypeList, setPenaltyTypeList] = useState([]);
    //#endregion
    //#region Effects
    useEffect(() => {
        fillData();
    }, []);
    //#endregion
    //#region Functions
    const isLibraryAdmin = () => {
        return [
            USER_ROLES.SUPERADMIN,
            USER_ROLES.RECURSOS_BIBLIOTECA_COORDINADOR
        ].includes(userRole);
    }
    const fillData = async () => {
        loadingRequest.show();
        try {
            let requestList = [
                fillCampusSpaces(),
                fillLibraryReasonsForPenalize(),
                fillUniversitySpaceReasonsForPenalize(),
                fillBlockList(),
                fillPenaltyTypeList()
            ];
            if (isLibraryAdmin()) 
                requestList = [
                    ...requestList,
                    fillResourceTypes(),
                ];
            await Promise.all(requestList);
        }
        catch (err) {
            setFatalError(true);
        }
        finally {
            loadingRequest.hide();
        }
    }
    const fillCampusSpaces = async () => {
        const data = await requestGetResourceModules(false);
        setCampusSpaceList(data);
    }
    const fillResourceTypes = async () => {
        const data = await requestGetResourceTypes();
        setResourceTypes(data);
    }
    async function fillLibraryReasonsForPenalize() {
        const data = await requestGetLibraryReasonsForPenalize();
        setLibraryReasonsForPenalize(data);
    }
    async function fillUniversitySpaceReasonsForPenalize() {
        const data = await requestGetUniversitySpaceReasonsForPenalize();
        setUniversitySpaceReasonsForPenalize(data);
    }
    const fillBlockList = async () => {
        const data = await requestGetBlockList();
        setBlockList(data);
    }
    const fillPenaltyTypeList = async () => {
        const data = await requestGetPenalties();
        setPenaltyTypeList(data);
    }
    //#endregion
    return {
        campusSpaceList,
        resourceTypes,
        libraryReasonsForPenalize, universitySpaceReasonsForPenalize,
        blockList, penaltyTypeList
    };
}

export default useDataRelatedToPenaltyAdmin;